const GET_TAX_PRODUCT_IBPT = "GET_TAX_PRODUCT_IBPT";


module.exports = {
    GET_TAX_PRODUCT_IBPT,
}
